export default {"en-US": __webpack_public_path__ + "i18n/en-US.5f3502d5.i18next.json","ja-JP": __webpack_public_path__ + "i18n/ja-JP.f8f90aeb.i18next.json"};